import React from "react";
import "bootstrap/dist/css/bootstrap.css";

import { Row, Col, Image } from "react-bootstrap";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaYoutubeSquare,
} from "react-icons/fa";
import "../component/Footer.css"; // Import custom CSS for marquee
import "../App.css";
import "../fonts/Steel_of_India.ttf";

const Footer = () => {
  return (
    <footer className="text-white py-3" style={{ backgroundColor: "#636466" }}>
      <div className="container-fluid">
        <div class="row">
          <div class="col-12">
            {/* Marquee Effect */}
            <div className="marquee">
              <p style={{ fontFamily: "Steel_of_India" }}>
                STEEL OF INDIA • STEEL OF INDIA • STEEL OF INDIA • STEEL OF
                INDIA • STEEL OF INDIA • STEEL OF INDIA • STEEL OF INDIA • STEEL
                OF INDIA • STEEL OF INDIA • STEEL OF INDIA • STEEL OF INDIA •
                STEEL OF INDIA
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-6">
            <p className="mb-0 footer-logo">
              <a href="https://www.jindalsteel.com/" target="_blank" rel="noopener noreferrer">
                <Image src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737812920jindal-logowhite.png" alt="jspl" width={100} />
              </a>
            </p>
          </div>
            
          
          <div className="col-12 col-md-6 social-section">
           
          
            <p className="mb-0 me-3">Our Channels</p>
            <a
              href="https://www.facebook.com/JSPLCorporate/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white mx-2"
            >
              <FaFacebook size={20} />
            </a>
            <a
              href="https://x.com/jsplcorporate"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white mx-2"
            >
              <FaTwitter size={20} />
            </a>
            <a
              href="https://www.instagram.com/jsplcorporate/?hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white mx-2"
            >
              <FaInstagram size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/jindal-steel-power-ltd-/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white mx-2"
            >
              <FaLinkedin size={20} />
            </a>
            <a
              href="https://www.youtube.com/jsplcorporate"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white mx-2"
            >
              <FaYoutubeSquare size={22} />
            </a>
          </div>
        </div>
        {/* Horizontal Line and Copyright Text */}
        <hr className="border-secondary my-3" />
        <Row>
          <Col className="text-start">
            <p className="mb-0 copyrighttext">&copy; Jindal Steel & Power Limited</p>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
